module.exports = __webpack_public_path__ + "img/ctrl-rz-theta-1.8da30d33.svg";